import axios from 'axios'
// import * as types from '../../store/types'
// import store from './../../store/modules/Authentication/authentication-store'

const authenticatedClient = axios.create({
  baseURL: process.env.VUE_APP_API,
  AccessControlAllowOrigin: '*',
  AccessControlAllowMethods: 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
  AccessControlAllowHeaders: 'X-Requested-With, content-type, token, language',
  AccessControlAllowContentType: 'application/x-www-form-urlencoded',
  AccessControlAllowCredentials: 'true',
 })

 authenticatedClient.interceptors.request.use(config => {
    // console.log('ok')
    // const token = store.getters[types.GET_AUTH_TOKEN]()
    // console.log('Store: ' + token)
    // if (token) {
    //   config.headers.common.Authorization = 'JWT ' + token
    // } else {
    //   delete config.headers.common.Authorization
    // }
    config.headers.common.Authorization = 'Bearer ' + localStorage.getItem('token')
    return config
})

authenticatedClient.interceptors.response.use(response => {
  return response
})

export default authenticatedClient
